export default "__VITE_ASSET__p8wAUA4Z__"